import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

export const useConfirmResetPasswordVerifyParams = (email: string, verifyCode: string) => {
	const [canRender, setCanRender] = useState(false);

	const navigate = useNavigate();

	useEffect(() => {
		if (!verifyCode && !email) {
			notifyUserEventInfo({
				title: "",
				description: "URLが正しくありません。メールを再度ご確認ください。",
			});

			navigate(PATHS.AUTH.FORGOT_PASSWORD);
		} else {
			setCanRender(true);
		}
	}, [navigate, email, verifyCode]);

	return {
		canRender,
	};
};
